// Helpers for errors shown on the global error page (app/error.vue).
//
// error.vue clears every error right after mounting to hide a spurious "page not found" on
// first init (#626). Errors we raise on purpose carry `data.persistent` so they stay visible.

export interface ErrorPageData {
  persistent?: boolean
  title?: string
}

// input for createError() when a /client/<uuid> route points to a client that does not exist
// (or is not visible for the current user - we deliberately don't tell those apart)
export const CLIENT_NOT_FOUND_ERROR = {
  statusCode: 404,
  statusMessage: 'Client Not Found',
  message: 'Diesen Kunden gibt es nicht oder Sie haben keinen Zugriff darauf.',
  fatal: true,
  data: { persistent: true, title: 'Kunde nicht gefunden' } satisfies ErrorPageData
}

export function isPersistentError (error: unknown): boolean {
  const data = (error as { data?: ErrorPageData } | null | undefined)?.data
  return data?.persistent === true
}

// The main navigation (BaseLayout) is only wrapped around errors we raised on purpose for a
// signed-in user: a generic error may stem from the layout itself (rendering it again would
// fail again), and BaseLayout redirects to the login when there is no session.
export function showNavigationOnErrorPage (error: unknown, authStatus: string): boolean {
  return authStatus === 'authenticated' && isPersistentError(error)
}

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isUuid (value: string): boolean {
  return UUID_REGEX.test(value)
}
